// extracted by mini-css-extract-plugin
export default {"header":"BorrowerDetails_header__fs-vi","list":"BorrowerDetails_list__GN0Ba","button":"BorrowerDetails_button__3ehX3"};